var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { Form, QuestionnaireService } from './questionnaire.service';
import { ItemAddRowDirective } from '../item/item-addrow.directive';
import { QuestionnaireDirective } from './questionnaire.directive';
var QuestionnaireComponent = /** @class */ (function (_super) {
    __extends(QuestionnaireComponent, _super);
    function QuestionnaireComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.items = [];
        _this.deleteItems = [];
        _this.seq = 1;
        _this.readonly = false;
        _this.pQuestion = [];
        _this.pParts = [];
        _this.pCopy = [];
        _this.cInputType = [];
        _this.cRequired = [];
        _this.initPanelVal = '0';
        return _this;
    }
    QuestionnaireComponent.prototype.ngOnInit = function () {
        var _this = this;
        _super.prototype.ngOnInit.call(this);
        this.subsc = this.service.observable.subscribe(function (flg) {
            if (flg) {
                _this.addLengthError();
                _this.addFormTypeError();
            }
        });
        this.getType();
        this.getQList();
        this.setCompRec();
    };
    QuestionnaireComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('HTMLTYPE').subscribe(function (rec) {
            _this.pQuestion = rec;
            _this.pQuestion.unshift({
                code: _this.initPanelVal,
                display: _this.msgSnapshot['au.COMPONENT.QuestionnaireComponent.select.select_question_type']
            });
        });
        this.service.getType('PAGE_PARTS').subscribe(function (rec) {
            _this.pParts = rec;
            _this.pParts.unshift({
                code: _this.initPanelVal,
                display: _this.msgSnapshot['au.COMPONENT.QuestionnaireComponent.select.select_page_parts']
            });
        });
        this.service.getType('QUESTIONNAIRE_INPUT_TYPE').subscribe(function (rec) { return _this.cInputType = rec; });
        this.service.getType('CODE_BOOLFLG').subscribe(function (rec) { return _this.cRequired = rec; });
    };
    QuestionnaireComponent.prototype.getQList = function () {
        this.pCopy = [];
        this.pCopy.push({
            code: this.initPanelVal,
            display: this.msgSnapshot['au.COMPONENT.QuestionnaireComponent.select.copy_question']
        });
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (item.panel_type !== "question" /* question */) {
                continue;
            }
            this.pCopy.push({ code: i + 1, display: item.name });
        }
    };
    QuestionnaireComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    QuestionnaireComponent.prototype.onSubscribe = function (data) {
        this.items = [];
        this.deleteItems = [];
        if (typeof data.items !== 'undefined' && data.items instanceof Array) {
            this.items = data.items;
            this.service.sortItems(this.items);
            this.addLengthError();
        }
        this.seq = 1;
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (typeof item.id !== 'undefined') {
                item.$type = "put" /* Put */;
            }
            if (item.form_type === "title" /* title */ || item.form_type === "image" /* image */ || item.form_type === "paging" /* paging */) {
                item.panel_type = "parts" /* parts */;
            }
            else {
                item.panel_type = "question" /* question */;
            }
            item.seq = this.seq++;
        }
        this.getQList();
        this.setCompRec();
    };
    QuestionnaireComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    QuestionnaireComponent.prototype.onEventSubscribe = function (e) {
        if (e === 'languageChange') {
            this.getType();
        }
    };
    QuestionnaireComponent.prototype.trackByItem = function (index, item) {
        return item.seq;
    };
    QuestionnaireComponent.prototype.onEvent = function (e1, e2, index) {
        if (e2 === 'add') {
            var form = new Form();
            form.seq = this.seq;
            this.items.splice(index + 1, 0, form);
            this.seq++;
        }
        else if (e2 === 'delete') {
            if (typeof this.items[index].id !== 'undefined' && this.items[index].id !== null) {
                this.items[index].$type = "delete" /* Delete */;
                this.deleteItems.push(this.items[index]);
            }
            this.items.splice(index, 1);
        }
        else if (e2 === 'up') {
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
        }
        else if (e2 === 'down') {
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
        }
        this.getQList();
        this.addLengthError();
        this.setCompRec();
    };
    QuestionnaireComponent.prototype.onChangePanel = function (e, index) {
        if (index === this.items.length) {
            this.onEvent(e, 'add', index);
        }
        if (e.panel_type === "copy" /* copy */) {
            this.onQCopy(e, index);
        }
        else {
            this.onChangeContents(e, index);
        }
        this.getQList();
        this.addLengthError();
        this.addFormTypeError(index);
        this.setCompRec();
    };
    QuestionnaireComponent.prototype.onChangeContents = function (e, index) {
        var form_type_old = this.items[index].form_type;
        var form_type_new = e.val;
        var panel_type_old = this.items[index].panel_type;
        var panel_type_new = e.panel_type;
        this.items[index].form_type = form_type_new;
        this.items[index].panel_type = panel_type_new;
        if (form_type_old === null) {
            return;
        }
        // ページパーツ: ページング に変更
        if (form_type_new === "paging" /* paging */ || form_type_new === null) {
            this.items[index].name = '';
            this.items[index].description = '';
            this.items[index].image_path = '';
            this.items[index].is_required = false;
            this.items[index].pa_type_name = '';
            this.items[index].max_length = null;
            this.items[index].questionnaire_form_element_m = [];
        }
        if (form_type_old === "image" /* image */ && form_type_new !== "image" /* image */) {
            // ページングパーツ: 画像 からそれ以外に変更
            this.items[index].image_path = '';
        }
        else if (form_type_old === "title" /* title */ && form_type_new !== "title" /* title */) {
            // ページングパーツ: テキスト からそれ以外に変更
            this.items[index].name = '';
        }
        else if (panel_type_old === "question" /* question */ && panel_type_new !== "question" /* question */) {
            // 質問タイプからページパーツに変更
            this.items[index].name = '';
            this.items[index].is_required = false;
        }
        // 選択肢がある質問タイプからそれ以外に変更
        if ((form_type_old === "radio" /* radio */ || form_type_old === "checkbox" /* checkbox */ || form_type_old === "select" /* select */) && form_type_new !== "radio" /* radio */ && form_type_new !== "checkbox" /* checkbox */ && form_type_new !== "select" /* select */) {
            this.items[index].questionnaire_form_element_m = [];
        }
        // 質問タイプ: テキスト、テキストエリアからそれ以外に変更
        if ((form_type_old === "text" /* text */ || form_type_old === "textarea" /* textarea */) && form_type_new !== "text" /* text */ && form_type_new !== "textarea" /* textarea */) {
            this.items[index].pa_type_name = '';
            this.items[index].max_length = null;
        }
    };
    QuestionnaireComponent.prototype.onQCopy = function (e, index) {
        if (e.val === null) {
            return;
        }
        var org_item = JSOG.parse(JSON.stringify(this.items[parseInt(e.val) - 1]));
        var item = this.items[index];
        item.panel_type = org_item.panel_type;
        item.form_type = org_item.form_type;
        item.name = org_item.name;
        item.description = org_item.description;
        item.image_path = org_item.image_path;
        item.is_required = org_item.is_required;
        item.pa_type_name = org_item.pa_type_name;
        item.max_length = org_item.max_length;
        var elements = org_item.questionnaire_form_element_m;
        for (var _i = 0, elements_1 = elements; _i < elements_1.length; _i++) {
            var element = elements_1[_i];
            delete element.id;
        }
        item.questionnaire_form_element_m = elements;
    };
    QuestionnaireComponent.prototype.onChangeElement = function (e, index) {
        this.items[index].questionnaire_form_element_m = e;
        this.setCompRec();
    };
    QuestionnaireComponent.prototype.onChange = function (e, key, index) {
        this.items[index][key] = e.val;
        if (key === 'name') {
            this.getQList();
        }
        this.setCompRec();
    };
    QuestionnaireComponent.prototype.setColumnVal = function (key, index) {
        var data = {};
        data[key + '-' + this.items[index].seq] = this.items[index][key];
        return data;
    };
    QuestionnaireComponent.prototype.setCompRec = function () {
        var order = 1;
        var page = 1;
        var q_no = 1;
        var items = JSOG.parse(JSON.stringify(this.items));
        items = items.concat(this.deleteItems);
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            item.disp_order = order++;
            item.page = page;
            if (item.form_type === "paging" /* paging */) {
                page++;
            }
            if (item.panel_type === "question" /* question */) {
                item.q_no = q_no++;
            }
            else {
                item.q_no = null;
            }
            if (item.form_type === "radio" /* radio */ || item.form_type === "checkbox" /* checkbox */ || item.form_type === "select" /* select */) {
                for (var _a = 0, _b = item.questionnaire_form_element_m; _a < _b.length; _a++) {
                    var element = _b[_a];
                    delete element.seq;
                    if (typeof element['cdate'] !== 'undefined') {
                        delete element['cdate'];
                    }
                    if (typeof element['cby'] !== 'undefined') {
                        delete element['cby'];
                    }
                    if (typeof element['udate'] !== 'undefined') {
                        delete element['udate'];
                    }
                    if (typeof element['uby'] !== 'undefined') {
                        delete element['uby'];
                    }
                    if (typeof element['base_status'] !== 'undefined') {
                        delete element['base_status'];
                    }
                }
            }
            else {
                item.questionnaire_form_element_m = [];
            }
            delete item.seq;
            delete item.panel_type;
        }
        this.action.setCompRec(this.componentName, { items: items });
    };
    QuestionnaireComponent.prototype.addLengthError = function () {
        this.dir.addRequiredError((this.items.length === 0 ? true : false), this.msgSnapshot['au.COMPONENT.QuestionnaireComponent.error.question_is_not_set']);
    };
    QuestionnaireComponent.prototype.addFormTypeError = function (idx) {
        var _this = this;
        if (idx >= 0) {
            this.formTypeDir.filter(function (item, index) { return index === idx; }).map(function (dir) {
                dir.addError(_this.msgSnapshot['au.COMPONENT.QuestionnaireComponent.error.question_type_is_not_set']);
            });
        }
        else {
            this.formTypeDir.map(function (dir) {
                dir.addError(_this.msgSnapshot['au.COMPONENT.QuestionnaireComponent.error.question_type_is_not_set']);
            });
        }
    };
    QuestionnaireComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.subsc.unsubscribe();
    };
    QuestionnaireComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'questionnaire',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"row -mb-1\">\n    <div class=\"col-sm-12\">\n      <p class=\"sectionHeading\">{{ (msg | async)['au.COMPONENT.QuestionnaireComponent.label.question_setting'] }}</p>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12 -ml-3\">\n      <div itemAddRowDir></div>\n      <ul class=\"form form-campaign\">\n        <li *ngFor=\"let item of items; let index = index; trackBy: trackByItem\" class=\"stageFlowPane\">\n          <div *ngIf=\"!readonly\" class=\"stageFlow_arrowsWrapper\">\n            <ul class=\"stageFlow_arrows\">\n              <li *ngIf=\"index > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n              <li *ngIf=\"index < items.length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li>\n            </ul>\n          </div>\n          <div class=\"stageFlowPane_border\">\n            <p *ngIf=\"!readonly\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"></a></p>\n            <!-- panel -->\n            <div class=\"stageFlowPane_border2\">\n              <div [item]=\"item\" questionnaireDir></div>\n              <questionnaire-panel [seq]=\"item.seq\" [val]=\"item.form_type\" [items]=\"items\" [readonly]=\"readonly\" [pQuestion]=\"pQuestion\" [pParts]=\"pParts\" [pCopy]=\"pCopy\" [msg]=\"(msg | async)\" (changePanel)=\"onChangePanel($event, index)\"></questionnaire-panel>\n            </div>\n            <!-- /panel -->\n            <!-- contents -->\n            <ng-template [ngIf]=\"item.form_type && item.form_type !== 'paging'\">\n              <div *ngIf=\"item.form_type === 'image'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.image_path'],\n                    key: 'image_path-' + item.seq,\n                    controlType: 'file',\n                    required: true,\n                    readonly: readonly,\n                    params: {\n                      formClass: {width: '100per'},\n                      uploadType: component.params?.uploadType\n                    }\n                  }\" [val]=\"setColumnVal('image_path', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'image_path', index)\"></column>\n                </div>\n              </div>\n              <div *ngIf=\"item.form_type === 'title'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.title'],\n                    key: 'name-' + item.seq,\n                    controlType: 'textarea',\n                    required: true,\n                    readonly: readonly,\n                    params: {formClass: {width: '100per'}, options: {rows: 5}}\n                  }\" [val]=\"setColumnVal('name', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'name', index)\"></column>\n                </div>\n              </div>\n              <div *ngIf=\"item.form_type !== 'image' && item.form_type !== 'title'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.name'],\n                    key: 'name-' + item.seq,\n                    controlType: 'text',\n                    required: true,\n                    readonly: readonly,\n                    params: {formClass: {width: '100per'}}\n                  }\" [val]=\"setColumnVal('name', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'name', index)\"></column>\n                </div>\n              </div>\n              <div class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.description'],\n                    key: 'description-' + item.seq,\n                    controlType: 'text',\n                    readonly: readonly,\n                    params: {formClass: {width: '100per'}}\n                  }\" [val]=\"setColumnVal('description', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'description', index)\"></column>\n                </div>\n              </div>\n              <div *ngIf=\"item.form_type === 'text' || item.form_type === 'textarea'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.max_length'],\n                    key: 'max_length-' + item.seq,\n                    controlType: 'number',\n                    readonly: readonly,\n                    params: {options: {min: 0}}\n                  }\" [val]=\"setColumnVal('max_length', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'max_length', index)\"></column>\n                </div>\n              </div>\n              <div *ngIf=\"item.form_type === 'text' || item.form_type === 'textarea'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.pa_type_name'],\n                    key: 'pa_type_name-' + item.seq,\n                    controlType: 'select',\n                    readonly: readonly,\n                    params: {options: cInputType}\n                  }\" [val]=\"setColumnVal('pa_type_name', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'pa_type_name', index)\"></column>\n                </div>\n              </div>\n              <div *ngIf=\"item.form_type === 'radio' || item.form_type === 'checkbox' || item.form_type === 'select'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <questionnaire-element\n                      [parent]=\"item.seq\"\n                      [other]=\"item.form_type === 'select' ? false : true\"\n                      [val]=\"item.questionnaire_form_element_m\"\n                      [readonly]=\"readonly\" [msg]=\"(msg | async)\" (changeElement)=\"onChangeElement($event, index)\"></questionnaire-element>\n                </div>\n              </div>\n              <div *ngIf=\"item.form_type !== 'title' && item.form_type !== 'image' && item.form_type !== 'paging'\" class=\"row -m-1 -mt-2\">\n                <div class=\"col-sm-12\">\n                  <column [key]=\"'form'\" [col]=\"{\n                    label: (msg | async)['au.COMPONENT.QuestionnaireComponent.label.is_required'],\n                    key: 'is_required-' + item.seq,\n                    controlType: 'radio',\n                    required: true,\n                    readonly: readonly,\n                    params: {options: cRequired}\n                  }\" [val]=\"setColumnVal('is_required', index)\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, 'is_required', index)\"></column>\n                </div>\n              </div>\n            </ng-template>\n            <!-- /contents -->\n          </div>\n          <button *ngIf=\"index < items.length - 1 && !readonly\" class=\"addBtn -mt-2\" type=\"button\" (click)=\"onEvent($event, 'add', index)\"></button>\n        </li>\n\n        <!-- panel -->\n        <li *ngIf=\"!readonly\" class=\"stageFlowPane\">\n          <div class=\"stageFlowPane_border\">\n            <div class=\"stageFlowPane_border2\">\n              <questionnaire-panel [seq]=\"0\" [val]=\"initPanelVal\" [items]=\"items\" [readonly]=\"readonly\" [pQuestion]=\"pQuestion\" [pParts]=\"pParts\" [pCopy]=\"pCopy\" [msg]=\"(msg | async)\" (changePanel)=\"onChangePanel($event, items.length)\"></questionnaire-panel>\n            </div>\n          </div>\n        </li>\n        <!-- /panel -->\n      </ul>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    QuestionnaireComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: QuestionnaireService }
    ]; };
    QuestionnaireComponent.propDecorators = {
        dir: [{ type: ViewChild, args: [ItemAddRowDirective,] }],
        formTypeDir: [{ type: ViewChildren, args: [QuestionnaireDirective,] }]
    };
    return QuestionnaireComponent;
}(ContentBaseComponent));
export { QuestionnaireComponent };
//# sourceMappingURL=questionnaire.component.js.map